import React, { useState, useEffect, useRef } from "react"; // useEffect 추가
import Modal from "react-modal";
import "./GosiRegisterPopup(custom).css";
import "./GosiRegisterPopup.css";
import Swal from "sweetalert2";
import axios from "axios";
import { getServerBaseUrl } from "../../../../utils/portConfig";
import Editor from "../../../../components/Dashboard/Editor";

function GosiRegister({ isOpen, onClose, onSave }) {
  const initialGosiRegData = {
    title: "",
    contents: "",
    evidence: "",
    grp: "",
    grpDetail: "",
  };

  const [gosiRegData, setGosiRegData] = useState({ ...initialGosiRegData });
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1/gosi`;
  const token = localStorage.getItem("token");

  // 에디터 ref 선언
  const editorRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGosiRegData({
      ...gosiRegData,
      [name]: value,
    });
  };

  useEffect(() => {
    setSelectedCategory("");
    setSelectedSubCategory("");
    getCategories();
  }, []);

  useEffect(() => {
    setSelectedSubCategory("");
    setSubCategories([]);
    getSubCategories();
  }, [selectedCategory]);

  useEffect(() => {
    if (!isOpen) {
      setGosiRegData({ ...initialGosiRegData });
      setSelectedCategory("");
      setSelectedSubCategory("");
    }
  }, [isOpen]);

  const getCategories = async () => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/groups`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // "code"와 "text" 필드를 모두 가져와서 "text"를 표시하고 "code"를 값으로 사용
      const categoriesData = response.data
        .filter((item) => !isNaN(item.code) && item.code)
        .map((mItem) => ({
          value: mItem.code,
          label: mItem.text,
        }));

      setCategories(categoriesData);
    } catch (error) {
      console.error("Category fetch error:", error);
      Swal.fire({
        title: "오류!",
        text: "데이터를 가져오는 중 오류가 발생했습니다.",
        icon: "error",
        showConfirmButton: true,
      });
    }
  };

  const getSubCategories = async () => {
    if (selectedCategory) {
      try {
        const response = await axios.get(`${API_SERVER_URL}/groups/${selectedCategory}/detail`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setSubCategories(response.data);
      } catch (error) {
        console.error("Subcategory fetch error:", error);
        Swal.fire({
          title: "오류!",
          text: "데이터를 가져오는 중 오류가 발생했습니다.",
          icon: "error",
          showConfirmButton: true, // 사용자가 확인 버튼을 눌러야 닫힙니다.
        });
      }
    } else {
      // If no category is selected, clear the subcategories
      setSubCategories([]);
      setSelectedSubCategory("");
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
  };

  const handleSaveClick = async () => {
    // 저장 시점에 현재 에디터 내용을 가져와서 저장
    let updateTagContents = "";
    let updateContents = "";

    if (editorRef.current) {
      const html = editorRef.current.getHTML();
      updateTagContents = html;

      // HTML에서 텍스트만 추출
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = html;
      updateContents = tempDiv.textContent || tempDiv.innerText || "";
    }

    const fileInput = document.getElementById("gregfileInputId").files[0];
    if (selectedCategory === "") {
      Swal.fire("알림", "분류를 선택해 주세요.", "warning");
      return;
    }
    if (selectedSubCategory === "") {
      Swal.fire("알림", "상세 분류를 선택해 주세요.", "warning");
      return;
    }
    if (gosiRegData.title === "") {
      Swal.fire("알림", "제목을 입력해 주세요.", "warning");
      return;
    }
    if (gosiRegData.evidence === "") {
      Swal.fire("알림", "관련 근거를 입력해 주세요.", "warning");
      return;
    }
    if (updateTagContents === "" || updateTagContents === "<p><br></p>") {
      Swal.fire("알림", "고시내용을 입력해 주세요.", "warning");
      return;
    }
    gosiRegData.regdt = currentTime;
    gosiRegData.grp = selectedCategory;
    gosiRegData.grpDetail = selectedSubCategory;

    const grpName = categories.filter((item) => Number(item.value) === Number(selectedCategory));
    const grpDetailName = subCategories.filter((sItem) => String(sItem.code) === String(selectedSubCategory));

    const gosiRegFormData = new FormData();
    gosiRegFormData.append("title", gosiRegData.title);
    gosiRegFormData.append("evidence", gosiRegData.evidence);
    gosiRegFormData.append("contents", updateContents);
    gosiRegFormData.append("tagcontents", updateTagContents);
    gosiRegFormData.append("regdt", currentTime);
    gosiRegFormData.append("grpCode", selectedCategory);
    gosiRegFormData.append("grpName", grpName[0].label);
    gosiRegFormData.append("grpDetailCode", selectedSubCategory);
    gosiRegFormData.append("grpDetailName", grpDetailName[0].text);

    if (fileInput !== undefined) {
      gosiRegFormData.append("files", fileInput);
    }
    onSave(gosiRegFormData);
  };

  const todayTime = () => {
    var today = new Date();
    var date = String(today.getFullYear()) + String(today.getMonth() + 1) + String(today.getDate());
    return date;
  };

  const currentTime = todayTime();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Gosi Reg Popup"
      style={{
        overlay: {
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        },
        content: {
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          border: "1px solid #ccc",
          background: "white",
          borderRadius: "4px",
          width: "900px", // 모달의 너비를 조정해 필요한 경우 수정
          height: "620px",
        },
      }}
    >
      <div className="gosi-custom-modal-header">
        <h2>고시 등록</h2>
      </div>
      <div className="gosi-custom-modal-content-flex">
        <div className="input-container">
          <div className="input-row" style={{ diplay: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <label htmlFor="gosiTitle">제목</label>
            <input type="text" name="title" value={gosiRegData.title} onChange={handleChange} placeholder="제목을 입력해 주세요." />
          </div>
        </div>
      </div>
      <div className="gosi-custom-modal-content gosi-custom-modal-content-align-left">
        <div className="search-container">
          <div className="search-group" style={{ display: "flex" }}>
            <div className="search-field" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <label className="s-label">분류</label>
              <select className="gosi-dashboard-content-select" value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} style={{ width: "150px" }}>
                <option value="">분류 선택</option>
                {categories.map((category, index) => (
                  <option key={index} value={category.value}>
                    {category.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="search-field" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <label className="s-label">상세 분류</label>
              <select className="gosi-dashboard-content-select" value={selectedSubCategory} onChange={(e) => setSelectedSubCategory(e.target.value)} style={{ width: "145px", marginLeft: "10px" }}>
                <option value="">상세분류 선택</option>
                {subCategories.map((subCategory, index) => (
                  <option key={index} value={subCategory.code}>
                    {subCategory.text}
                  </option>
                ))}
              </select>
            </div>
            <div className="gosi-input-row" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <label className="i-label">관련 근거</label>
              <div className="evidence-input">
                <input type="text" name="evidence" value={gosiRegData.evidence} onChange={handleChange} maxLength={12} placeholder={"12자 이상 입력할 수 없습니다."} />
              </div>
            </div>
            <div className="gosi-input-row" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <label className="i-label">첨부파일</label>
              <div className="gregfileInput">
                <input type="file" id="gregfileInputId" name="gregfileInput" onChange={handleFileChange} />
                {/*gosiRegister줄여서 greg*/}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="gosi-custom-modal-content gosi-custom-modal-content-align-right">
        <div className="input-container">
          <div className="input-row" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
            <label htmlFor="hospitalInfo" style={{ marginBottom: "5px" }}>
              고시 내용
            </label>
            <div id="gosi-editor-container" className="gosi-editor-container">
              <Editor ref={editorRef} readOnly={false} initialHTML={gosiRegData.tagcontents} placeholder="등록할 고시 내용을 입력하세요." />
            </div>
          </div>
        </div>
      </div>
      <div className="gosi-custom-button-container">
        <button className="dashboard-content-button popup-button" onClick={handleSaveClick}>
          저장
        </button>
        <button className="dashboard-content-button red-button popup-button" onClick={onClose}>
          취소
        </button>
      </div>
    </Modal>
  );
}

export default GosiRegister;
